import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  PropTypes: {
    isActive: PropTypes.bool.isRequired,
    padding: PropTypes.string,
    margin: PropTypes.string,
    fontSize: PropTypes.string,
  },
  render() {
    if (this.props.isActive) {
      var padding = this.props.padding ? this.props.padding : "30px";
      var margin = this.props.margin ? this.props.margin : "0 auto";
      var fontSize = this.props.fontSize ? this.props.fontSize : "";
      return (
        <div
          style={{
            padding: padding,
            margin: margin,
            fontSize: fontSize,
            textAlign: "center",
          }}
        >
          <i className="fas fa-spinner fa-pulse fa-2x fa-fw" />
        </div>
      );
    } else {
      return null;
    }
  },
});
